import { render } from "./EducationHistory.vue?vue&type=template&id=1f702c34"
import script from "./EducationHistory.vue?vue&type=script&lang=js"
export * from "./EducationHistory.vue?vue&type=script&lang=js"

import "./EducationHistory.vue?vue&type=style&index=0&id=1f702c34&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__